<template>
		<vxe-modal v-model="modalShow" destroy-on-close :width="800" :height="800" show-footer @show="show" @hide="hide"
			transfer :lock-scroll="false">
			<template #title>
				<div>选择人员</div>
			</template>
			<template #default>
				<el-tabs v-model="activeName" @tab-click="handleClick" type="card">
					<el-tab-pane label="人员" name="modalStaff">
						<modalStaff :staffid="staffid" :multiple="islist || multiple" ref="modalStaff" />
					</el-tab-pane>
				</el-tabs>
				<transition name="el-fade-in-linear">
					<div class="full flex form_loading" v-if="loading"
						style="background-color: rgba(255, 255, 255, .5);z-index: 999;color: #409EFF;">
						<i class="vxe-icon-refresh roll"></i>
						<span>正在加载</span>
					</div>
				</transition>
			</template>
			<template #footer>
				<vxe-button status="" content="取消" @click="modalShow=false"></vxe-button>
				<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import modalStaff from '@_system/components/auth/staff.vue'
	export default {
		props:{
			islist: {
				default: () => {
					return false
				}
			},
			multiple: {
				default: () => {
					return false
				}
			},
			staffid: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				//staffid: [],
				activeName: 'modalStaff',
				modalShow: false,
				loading: false
			}
		},
		created() {


		},
		watch: {

		},
		computed: {

		},
		methods: {
			modal_show(){
				this.modalShow = true
			},
			list() {
				if (!window.systemData.staff) {
					this.$api.staff.list({
						currentPage: -1
					}).then((res) => {
						let options = []
						res.list.forEach((item) => {
							options.push({
								value: item.id,
								label: item.name,
								status: item.status,
								enable: item.enable,
								departmentid: item.departmentid
							})
						})
						this.options = options
						this.finish()
					})
				} else {
					let list = JSON.parse(JSON.stringify(window.systemData.staff))
					let options = []
					list.forEach((item) => {
						options.push({
							value: item.id,
							label: item.name,
							status: item.status,
							enable: item.enable,
							departmentid: item.departmentid
						})
					})
					this.options = options
					this.finish()
				}
				
			},
			init() {


			},
			show() {

			},
			hide() {
				this.loading = false
				this.back()
			},
			handleClick() {

			},
			submit() {
				let data = this.$refs.modalStaff.submitData()
				this.$emit('submit', {
					data: data
				})
				this.back()
			},
			back() {
				this.modalShow = false
			}
		},
		components: {
			modalStaff
		}
	}
</script>
